import { httpClient, ApiResponse } from '@/utils';
import { staticFaqChannelEndpoints, IGetFaqChannelsResponse } from '@/models/faqChannel.model';

class FaqChannelsAPI {
  static getFaqChannels(): ApiResponse<IGetFaqChannelsResponse> {
    const { GET_FAQ_CHANNELS } = staticFaqChannelEndpoints;
    return httpClient.get<IGetFaqChannelsResponse>(GET_FAQ_CHANNELS);
  }
}

export default FaqChannelsAPI;
